module.exports = __webpack_public_path__ + "img/register-button-disabled.4fd5b5e2.png";